document.addEventListener('DOMContentLoaded', function () {
  // Get the current script's file name
  const fileName = 'form-dealer-popup';

  // Find the custom form popup associated with this script
  const popup = document.querySelector(`[data-form-name="${fileName}"]`);

  if (!popup) {
    console.error(`Popup not found for ${fileName}`);
    return;
  }

  const formDataElement = document.getElementById(`form-data-${fileName}`);

  if (!formDataElement) {
    console.error(`Form data not found for ${fileName}`);
    return;
  }

  const formData = JSON.parse(formDataElement.textContent);
  const form = document.getElementById(formData.formId);
  const closePopup = document.querySelector(formData.closeButtonSelector);
  const showPopupButtons = document.querySelectorAll('[show-dealer-popup]');

  // Updated preFillForm function to handle zip input lookup
  function preFillForm(button) {
    const name = button.getAttribute('data-name');
    const address1 = button.getAttribute('data-address1');
    const address2 = button.getAttribute('data-address2');
    const city = button.getAttribute('data-city');
    const state = button.getAttribute('data-state');
    const zip = button.getAttribute('data-zip');

    function buildDealerAddress() {
      if (!address2) {
        if (!address1) {
          return `${city}, ${state} ${zip}`;
        }
        return `${address1} <br> ${city}, ${state} ${zip}`;
      }
      return `${address1} <br> ${address2} <br> ${city}, ${state} ${zip}`;
    }

    // Update title and subheading
    const title = popup.querySelector('h3.title');
    const subheading = popup.querySelector('.subheading');
    if (title) title.textContent = name;
    if (subheading) subheading.innerHTML = buildDealerAddress();

    // Get the element with the 'selected-zip' data attribute
    const zipElement = document.getElementById('selected-zip');
    const selectedZip = zipElement ? zipElement.getAttribute('data-selected-zip') : null;

    // Get the vehicle model from the data attribute, check if vehicleModelSelector exists
    const vehicleModelSelector = document.querySelector('.select-container');
    let selectedVehicle = null;

    if (vehicleModelSelector) {
      const vehicleSpan = vehicleModelSelector.querySelector('.disclosure__button span');
      selectedVehicle = vehicleSpan ? vehicleSpan.getAttribute('data-selected-vehicle') : null;
    }

    // Get form fields by querying within the form, ensure form elements exist
    const zipInput = form.querySelector('#zip-code');
    const truckModelInput = form.querySelector('#truck-model');

    // Pre-fill the form fields
    if (selectedZip && zipInput) zipInput.value = selectedZip || '';
    if (selectedVehicle && truckModelInput) truckModelInput.value = selectedVehicle || '';

    // Initialize the geocoder for zip input to lookup city and state
    initializeGeocoder(selectedZip);
  }

  function onPopupCloseEnd(event) {
    if (event.target !== popup || event.propertyName !== 'opacity') return;
    popup.classList.add('hidden');
    popup.removeEventListener('transitionend', onPopupCloseEnd);
  }

  function openPopup(trigger) {
    popup.removeEventListener('transitionend', onPopupCloseEnd);
    popup.classList.remove('hidden');
    requestAnimationFrame(() => {
      popup.classList.add('show');
    });
    preFillForm(trigger);
  }

  function closePopupModal() {
    if (popup.classList.contains('hidden') && !popup.classList.contains('show')) return;
    popup.classList.remove('show');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      popup.classList.add('hidden');
      return;
    }
    popup.addEventListener('transitionend', onPopupCloseEnd);
  }

  if (showPopupButtons.length > 0) {
    showPopupButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        openPopup(this);
      });
    });
  }

  if (closePopup) {
    closePopup.addEventListener('click', closePopupModal);
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      closePopupModal();
    });
  }
});

// Geocoding function to lookup city and state from zip code
async function initializeGeocoder(zip) {
  const { Geocoder } = await google.maps.importLibrary('geocoding');

  const cityInput = document.getElementById('city');
  const stateProvinceInput = document.getElementById('state');

  const geocoder = new Geocoder();

  if (!zip) {
    cityInput.value = '';
    stateProvinceInput.value = '';
    return;
  }

  cityInput.value = 'Looking up City...';
  stateProvinceInput.value = 'Looking up State / Province...';

  try {
    const response = await geocoder.geocode({ address: zip });

    if (response.results && response.results[0]) {
      const result = response.results[0];
      const addressComponents = result.address_components;
      const city = addressComponents.find((component) => component.types.includes('locality'))?.long_name || '';
      const state =
        addressComponents.find((component) => component.types.includes('administrative_area_level_1'))?.short_name ||
        '';

      cityInput.value = city;
      stateProvinceInput.value = state;
    } else {
      cityInput.value = '';
      stateProvinceInput.value = '';
    }
  } catch (error) {
    console.error('Geocoding failed:', error);
    cityInput.value = '';
    stateProvinceInput.value = '';
  }
}

function gm_authFailure() {
  console.error('Google Maps authentication failed. Please check your API key and restrictions.');
}
